import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massForceDeleteTestimonials } from "../../api/apiTestimonials";
import parseError from "../../utils/parseError";

export function useForceDeleteAllTestimonials() {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAllItemsMutate, isPending } = useMutation({
        mutationFn: massForceDeleteTestimonials,
        onSuccess: (response) => {
            toast.success(response.message || "Force deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["testimonials"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to force delete testimonials");
        },
    });

    return { forceDeleteAllItemsMutate, isPending };
}
